import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  Header,
  Button,
  Grid,
  Segment,
  Label,
  Dropdown,
  Form,
  Icon,
} from "semantic-ui-react";
import { fetchExams, fetchClients, fetchExamTypes } from "../../reducers/exam";
import { getClientsByType } from "./../../lib/clientService";
import { withTranslation } from "react-i18next";
import ExamDetails from "./ExamDetails";
import _ from "underscore";

class SelectExam extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      selectedExam: this.props.formData.exam || {},
      selectedClient: this.props.formData.client || {},
      selectedType: this.props.formData.type || {},
      options: [],
      clientOptions: {
        "": [],
      },
      typeOptions: [], // Add options for types
    };
  }
  updateSelected = (event, data) => {
    // Find the selected exam by value (id)
    const selectedExam = this.props.exam.allExams.find(
      (exam) => String(exam.id) === String(data.value),
    );

    // Set both the full exam object and its value property for controlled Dropdown
    this.setState(
      {
        selectedExam: selectedExam
          ? { ...selectedExam, value: String(selectedExam.id) }
          : {},
      },
      () => {},
    );
  };

  updateClientSelected = (event, data) => {
    const selectedClient = this.props.exam.clients.filter(function (client) {
      return parseInt(client.value, 10) === parseInt(data.value, 10);
    });
    this.setState(
      {
        selectedClient: selectedClient[0],
      },
      () => {
        this.updateExamOptions();
      },
    );
  };
  updateTypeSelected = async (event, data) => {
    let clientOptions = this.state.clientOptions[data.value];
    if (clientOptions === undefined) {
      if (data.value === "any") {
        clientOptions = this.props.exam.clients.map((client) => ({
          key: `${client.value}`,
          value: `${client.value}`,
          text: client.text,
        }));
      } else {
        const clients = await getClientsByType(data.value);
        clientOptions = clients.map((client) => ({
          key: `${client.id}`,
          value: `${client.id}`,
          text: client.organization_name,
        }));
      }
      clientOptions.sort(function (a, b) {
        var textA = a.text.toUpperCase();
        var textB = b.text.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    }

    this.setState(
      {
        selectedType: { value: data.value },
        clientOptions: {
          [data.value]: clientOptions,
          ...this.state.clientOptions,
        },
      },
      () => {
        this.updateExamOptions();
      },
    );
  };
  updateExamOptions() {
    let examOptions = [];

    this.props.exam.allExams.reduce((res, data) => {
      if (data.deleted === null) {
        const typeMatches =
          this.state.selectedType.value === "any" ||
          data.type === this.state.selectedType.value;
        const clientMatches = data.clients.filter(
          (e) => e.id === this.state.selectedClient.value,
        );
        if (typeMatches && clientMatches.length > 0) {
          examOptions.push({
            key: `${data.id}`,
            value: `${data.id}`,
            text: data.title,
          });
        }
      }
      return null;
    }, []);

    examOptions.sort(function (a, b) {
      var textA = a.text.toUpperCase();
      var textB = b.text.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    // Reset the selected exam if the options are empty or the current selection is invalid
    const resetSelectedExam =
      examOptions.length === 0 ||
      !examOptions.some(
        (option) => option.value === this.state.selectedExam.value,
      );

    this.setState({
      options: examOptions,
      selectedExam: resetSelectedExam ? {} : this.state.selectedExam,
    });
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.props.onForward({
      exam: this.state.selectedExam,
      clientId: this.state.selectedClient.value,
      type: this.state.selectedType.value,
    });
  };

  async componentDidMount() {
    this.props.fetchExams();
    this.props.fetchClients();
    this.props.fetchExamTypes(); // Dispatch action to fetch exam types
  }

  render() {
    let clients = [];
    this.props.exam.clients.forEach((client) => {
        clients.push({
          key: `${client.value}`,
          value: `${client.value}`,
          text: client.text,
        });
    });
    clients.sort(function (a, b) {
      var textA = a.text.toUpperCase();
      var textB = b.text.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    const groupedTypes = this.props.exam.examTypes.map((type, index) => ({
      key: index + 1,
      value: type,
      text: type,
    }));
    groupedTypes.sort(function (a, b) {
      var textA = a.text.toUpperCase();
      var textB = b.text.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    groupedTypes.unshift({ key: 0, value: "any", text: this.props.t("general.all") }); // Add "Any" option
    return (
      <Container>
        <Form>
          <Segment padded>
            <Grid.Column>
              {/* Type Dropdown */}
              <Form.Field>
                {!this.state.selectedType.value ? (
                  <Label pointing="below">
                    {this.props.t("SelectExam.selectType")}
                  </Label>
                ) : (
                  ""
                )}
                <Dropdown
                  deburr
                  fluid
                  options={groupedTypes} // Use types from state
                  value={this.state.selectedType.value || ""} // Ensure value is controlled
                  onChange={this.updateTypeSelected}
                  placeholder={this.props.t("SelectExam.selectType")}
                  search
                  selection
                />
              </Form.Field>

              <Form.Field>
                {_.isEmpty(this.state.selectedClient) &&
                this.state.selectedType.value ? (
                  <Label pointing="below">
                    {this.props.t("SelectExam.selectTrainingProvider")}
                  </Label>
                ) : (
                  ""
                )}
                <Dropdown
                  deburr
                  fluid
                  options={
                    this.state.clientOptions[this.state.selectedType.value] ||
                    []
                  }
                  onChange={this.updateClientSelected}
                  placeholder={this.props.t("SelectExam.selectExamProvider")}
                  search
                  selection
                />
              </Form.Field>
              <Form.Field>
                {_.isEmpty(this.state.selectedExam.value) &&
                this.state.selectedType.value &&
                !_.isEmpty(this.state.selectedClient) ? (
                  <Label pointing="below">
                    {this.props.t("SelectExam.selectExam")}
                  </Label>
                ) : (
                  ""
                )}
                <Dropdown
                  deburr
                  fluid
                  options={this.state.options}
                  value={this.state.selectedExam.value || ""} // Controlled by value
                  onChange={this.updateSelected}
                  placeholder={this.props.t("SelectExam.selectExam")}
                  search
                  selection
                />
              </Form.Field>
            </Grid.Column>
          </Segment>

          <ExamDetails
            step={this.props.step}
            duration={this.state.selectedExam.duration}
            cost={this.state.selectedExam.cost || 0.0}
            description={this.state.selectedExam.description}
          />

          <Segment>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Button
                    onClick={this.onSubmit}
                    disabled={_.isEmpty(this.state.selectedExam)}
                    positive
                    floated="right"
                  >
                    <Button.Content visible>
                      {this.props.t("general.next")}
                      <Icon name="right arrow" />
                    </Button.Content>
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Form>
      </Container>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      kc: state.keycloak,
      exam: state.exam,
    }),
    {
      fetchExams,
      fetchClients,
      fetchExamTypes,
    },
  )(SelectExam),
);
